import styled from 'styled-components'

export const BottomWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    font-weight: 500;
    padding-top: 2rem;
    padding-bottom: 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        width: 95%;
    }
`

export const LeftColumn = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    @media (max-width: 768px) {
        justify-content: center;
        margin-bottom: 1rem;
    }
`

export const RightColumn = styled.div`
    @media (max-width: 768px) {
        text-align: center;
    }
`

export const Link = styled.a`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`

export const Text = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    margin: 0;
`
